import React from "react";
import { connect } from "react-redux";
import * as THREE from "three";
import toothManager from "../../../../data/manager/toothManager";
import ToothModel from "../../../../Components/CreateModal/ToothModel";
import { TOOTH_PARTS_TYPE } from "../../../../data/constant/toothConstant";
import AttachModel from "../../../../Components/CreateModal/AttachModel";
import BiteStopModel from "../../../../Components/CreateModal/BiteStopModel";
import CutoutModel from "../../../../Components/CreateModal/CutoutModel";
import HookModel from "../../../../Components/CreateModal/HookModel";
import SlitModel from "../../../../Components/CreateModal/SlitModel";
import { getOpacity } from "../../../../common/tooth";
import { getMode } from "../../../../utils";

function ToothDataPro2(props) {
  const {
    sliderVal,
    keyframeNumber,
    attachmentCheckboxValue,
    biteStopCheckboxValue,
    cutoutsCheckboxValue,
  } = props;

  const toothModelList = toothManager.getToothModelList();
  const { readOnlyMode } = getMode();
  const attachmentColor = readOnlyMode ? "#FFFFFF" : "#BBABFF";

  const stageNumber = keyframeNumber + 1;

  /**
   * @description   set data
   * */

  /**
   * @description adjust model opacity
   * */

  return (
    <group name={"toothAndItem"}>
      {
        toothModelList.map((toothModel) => {
          const { toothGumType, toothNumber, toothIndex, model } = toothModel;
          const toothPartsModelList =
            toothManager.getToothPartsModelListByToothNumber(toothNumber);
          const target = model || new THREE.BufferGeometry();
          const toothMatrix =
            toothManager.getToothMatrixByStageNumberAndToothGumTypeAndToothIndex(
              stageNumber,
              toothGumType,
              toothIndex
            );
          const toothVisible =
            toothManager.getToothVisibleByStageNumberAndToothGumTypeAndToothIndex(
              stageNumber,
              toothGumType,
              toothIndex
            );

          let opacity = getOpacity(toothGumType, sliderVal);

          return (
            <group
              matrix={toothMatrix}
              matrixAutoUpdate={false}
              name={toothNumber}
              visible={toothVisible === 1 ? true : false}
            >
              <ToothModel
                toothGumType={toothGumType}
                toothNumber={toothNumber}
                toothIndex={toothIndex}
                model={target}
                opacity={opacity}
              />
              {toothPartsModelList.map((toothPartsModel) => {
                const { toothPartsType, model } = toothPartsModel;
                return (
                  <>
                    {toothPartsType === TOOTH_PARTS_TYPE.ATTACH && (
                      <AttachModel
                        color={attachmentColor}
                        model={model}
                        visible={attachmentCheckboxValue}
                        opacity={opacity}
                      />
                    )}
                    {toothPartsType === TOOTH_PARTS_TYPE.BITESTOP && (
                      <BiteStopModel
                        model={model}
                        visible={biteStopCheckboxValue}
                        opacity={opacity}
                      />
                    )}
                    {toothPartsType === TOOTH_PARTS_TYPE.CUTOUT && (
                      <CutoutModel
                        model={model}
                        visible={cutoutsCheckboxValue}
                        opacity={opacity}
                      />
                    )}
                    {toothPartsType === TOOTH_PARTS_TYPE.HOOK && (
                      <HookModel
                        model={model}
                        visible={cutoutsCheckboxValue}
                        opacity={opacity}
                      />
                    )}
                    {toothPartsType === TOOTH_PARTS_TYPE.SLIT && (
                      <SlitModel
                        model={model}
                        visible={cutoutsCheckboxValue}
                        opacity={opacity}
                      />
                    )}
                  </>
                );
              })}
            </group>
          );
        })
        // toothData.map((toothItem, toothIndex)=> {
        //     return(
        //         <group matrix={getToothMatrix(toothData, stage, toothIndex)}  matrixAutoUpdate={false} name={toothItem.number} visible={(getToothVisible(toothData, stage, toothIndex) === 1 && stage === keyframeNumber) ? true : false}>
        //             <Tooth
        //                 itemId={toothItem.number}
        //                 toothIndex={toothIndex}
        //                 stage={stage}
        //                 key={toothItem.number}
        //                 isUpper={isUpper}
        //                 url={getToothUrl(toothData, toothIndex)}
        //                 opacity={opacity}
        //                 scale={(getToothVisible(toothData, stage, toothIndex) === 1 && stage === keyframeNumber) ? 1 : 0}
        //                 fileType={getToothFileType(toothData, toothIndex)}
        //             />
        //             <group name={'item'}>
        //                 {/*initTooth is used because the tooth in overlay mode does not need to have these components */}
        //                 {
        //                     toothItem.children.map(val => {
        //                         return(
        //                             <>
        //                                 {
        //                                     val.url!=='' && val.type==='attachment' ? <Attachment url={val.url} fileType={val.fileType} toothNumber={toothItem.number} isUpper={isUpper} type={val.type} opacity={opacity} /> : <></>
        //                                 }
        //                                 {
        //                                     val.url!=='' && val.type==='hooks' ? <Hooks url={val.url} fileType={val.fileType} toothNumber={toothItem.number} isUpper={isUpper} type={val.type} opacity={opacity} /> : <></>
        //                                 }
        //                                 {
        //                                     val.url!=='' && val.type==='cutouts' ? <Cutouts url={val.url} fileType={val.fileType} toothNumber={toothItem.number} isUpper={isUpper} type={val.type} opacity={opacity} /> : <></>
        //                                 }
        //                                 {
        //                                     val.url!=='' && val.type==='biteStop' ? <BiteStop url={val.url} fileType={val.fileType} toothNumber={toothItem.number} isUpper={isUpper} type={val.type} opacity={opacity} /> : <></>
        //                                 }
        //                                 {
        //                                     val.url!=='' && val.type==='slits' ? <Slits url={val.url} fileType={val.fileType} toothNumber={toothItem.number} isUpper={isUpper} type={val.type} opacity={opacity} /> : <></>
        //                                 }
        //                             </>
        //                         )
        //                     })
        //                 }
        //             </group>
        //         </group>
        //     )
        // })
      }
    </group>
  );
}

const mapStateToProps = (state) => ({
  sliderVal: state.webViewer.sliderVal,
  keyframeNumber: state.webViewer.keyframeNumber,
  attachmentCheckboxValue: state.webViewer.attachmentCheckboxValue,
  biteStopCheckboxValue: state.webViewer.biteStopCheckboxValue,
  cutoutsCheckboxValue: state.webViewer.cutoutsCheckboxValue,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ToothDataPro2);
